import van from "vanjs-core";
import {Footer} from "./page1/footer";
import {MainContent} from "./page1/main-content";
import {Header} from "./page1/header";

const {div} = van.tags;

// 1. obrazovka
export const Page1 = () => {
    return div({class: 'bg-primary w-100 d-flex flex-column min-h-100-v'},
        Header,
        MainContent,
        Footer
    );
};